module.exports = __webpack_public_path__ + "media/comboSmash-highScores@xs-3b5d094251eabab5382ed3529ddf2795.jpg";